import axios from '@websanova/vue-auth/drivers/http/axios.1.x'
import router from '@websanova/vue-auth/drivers/router/vue-router.2.x'

const config = {
	auth: {
	    request: function (req, token) {
	        this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token});
	    },
	    
	    response: function (res) {
	    	var token = res.data.token_jwt

	        if (token) {
	            token = token.split(/Bearer\:?\s?/i);
	            
	            return token[token.length > 1 ? 1 : 0].trim();
	        }
	    }
	},
	http: axios,
	router: router,
	tokenDefaultName: 'laravel-jwt-auth',
	tokenStore: ['localStorage'],
	rolesVar: 'role', 
	registerData: {
		url: 'auth/register', 
		method: 'POST', 
		redirect: false, 
	},
	loginData: {
		url: 'auth/login', 
		method: 'POST', 
		redirect: false, 
		fetchUser: true
	},
	logoutData: {
		url: 'auth/logout', 
		method: 'POST', 
		redirect: '/login',
		makeRequest: true
	},
	fetchData: {
		url: 'auth/user', 
		method: 'GET', 
		enabled: true
	},
	refreshData: {
		url: 'auth/refresh', 
		method: 'GET', 
		enabled: true, 
		interval: 30
	}
}
export default config